import React from 'react';
import PropTypes from 'prop-types';
import {MediaUploadWithThumbnailDisplayQA} from 'src/components/PreQuestion/MediaUpload';
import { isImmutable } from 'src/utils/helpers';

/* HOPEFULLY:  This will never be used. */
const BACKUP_NAMESPACE = 'qa';

const PreQuestionMedia = ({ question, value, onChange, error }) => {
  const hintText = question.get('hint');
  const label = question.get('textDirect');
  const mediaValue = isImmutable(value) ? value.toJS() : value;

  return (
    <div className="positionRelative">
      <span><label className="input-label-medium">{label}</label></span>
      {hintText && <p className="p1 n800 paddingTop-small">{hintText}</p>}
        <MediaUploadWithThumbnailDisplayQA
          seedValue={mediaValue}
          onChange={onChange}
          size={104}
          namespace={question.get('id') || BACKUP_NAMESPACE}
          error={error}
        />
    </div>
  );
};

PreQuestionMedia.propTypes = {
  question: PropTypes.object.isRequired,
  error: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PreQuestionMedia;
